import { render, staticRenderFns } from "./ModalMarket.vue?vue&type=template&id=1a6ecec5&lang=pug&"
import script from "./ModalMarket.vue?vue&type=script&lang=js&"
export * from "./ModalMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports